import { useThreadConfig } from '#pplx/frontend/apps/ask/providers/ThreadSettingsProviderShared.js';
import { useSearchModeForSearchModel } from '#pplx/frontend/apps/ask/search/hooks/useSearchModeForSearchModel.js';
import { isSidecarSupportedMode, SearchMode, } from '#pplx/frontend/ask-models/types/search-modes.js';
import { useMemo } from 'react';
export function useSelectedSearchMode() {
    const { configuredModel } = useThreadConfig();
    const getSearchModeForSearchModel = useSearchModeForSearchModel();
    return useMemo(() => {
        if (import.meta.env.VITE_IS_SIDECAR_BUILD) {
            const mode = getSearchModeForSearchModel(configuredModel);
            // Reject modes unsupported in sidecar that may leak through shared
            // thread/model initialization paths.
            return isSidecarSupportedMode(mode) ? mode : SearchMode.SEARCH;
        }
        return getSearchModeForSearchModel(configuredModel);
    }, [configuredModel, getSearchModeForSearchModel]);
}
//# sourceMappingURL=useSelectedSearchMode.js.map